/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BillingAdditionalProgramAddParams,
    BillingAdditionalProgramAddParamsFromJSON,
    BillingAdditionalProgramAddParamsToJSON,
    BillingDetails,
    BillingDetailsFromJSON,
    BillingDetailsToJSON,
    BillingDetailsCreateParams,
    BillingDetailsCreateParamsFromJSON,
    BillingDetailsCreateParamsToJSON,
    BillingProductAddParams,
    BillingProductAddParamsFromJSON,
    BillingProductAddParamsToJSON,
    BillingProductList,
    BillingProductListFromJSON,
    BillingProductListToJSON,
    CurrencyCode,
    CurrencyCodeFromJSON,
    CurrencyCodeToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    ProgramList,
    ProgramListFromJSON,
    ProgramListToJSON,
} from '../models';

export interface AddAdditionalProgramBillingRequest {
    program_id: string;
    BillingAdditionalProgramAddParams: BillingAdditionalProgramAddParams;
}

export interface AddProductBillingRequest {
    program_id: string;
    BillingProductAddParams: BillingProductAddParams;
}

export interface CreateBillingRequest {
    program_id: string;
    BillingDetailsCreateParams: BillingDetailsCreateParams;
}

export interface FindAdditionalProgramBillingRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindOneBillingRequest {
    program_id: string;
}

export interface FindPlansBillingRequest {
    currency: CurrencyCode;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface FindProductsBillingRequest {
    currency: CurrencyCode;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
}

export interface RemoveAdditionalProgramBillingRequest {
    program_id: string;
    id: string;
}

export interface RemoveProductBillingRequest {
    program_id: string;
    id: string;
}

export interface UpdateBillingRequest {
    program_id: string;
    BillingDetails: BillingDetails;
}

/**
 * 
 */
export class BillingApi extends runtime.BaseAPI {

    /**
     * Add additional program to subscription
     */
    async addAdditionalProgramBillingRaw(requestParameters: AddAdditionalProgramBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling addAdditionalProgramBilling.');
        }

        if (requestParameters.BillingAdditionalProgramAddParams === null || requestParameters.BillingAdditionalProgramAddParams === undefined) {
            throw new runtime.RequiredError('BillingAdditionalProgramAddParams','Required parameter requestParameters.BillingAdditionalProgramAddParams was null or undefined when calling addAdditionalProgramBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing/additional_programs`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillingAdditionalProgramAddParamsToJSON(requestParameters.BillingAdditionalProgramAddParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Add additional program to subscription
     */
    async addAdditionalProgramBilling(requestParameters: AddAdditionalProgramBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.addAdditionalProgramBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add product to subscription
     */
    async addProductBillingRaw(requestParameters: AddProductBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling addProductBilling.');
        }

        if (requestParameters.BillingProductAddParams === null || requestParameters.BillingProductAddParams === undefined) {
            throw new runtime.RequiredError('BillingProductAddParams','Required parameter requestParameters.BillingProductAddParams was null or undefined when calling addProductBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing/products`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillingProductAddParamsToJSON(requestParameters.BillingProductAddParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Add product to subscription
     */
    async addProductBilling(requestParameters: AddProductBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.addProductBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create billing details
     */
    async createBillingRaw(requestParameters: CreateBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createBilling.');
        }

        if (requestParameters.BillingDetailsCreateParams === null || requestParameters.BillingDetailsCreateParams === undefined) {
            throw new runtime.RequiredError('BillingDetailsCreateParams','Required parameter requestParameters.BillingDetailsCreateParams was null or undefined when calling createBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BillingDetailsCreateParamsToJSON(requestParameters.BillingDetailsCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Create billing details
     */
    async createBilling(requestParameters: CreateBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.createBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all addition programs
     */
    async findAdditionalProgramBillingRaw(requestParameters: FindAdditionalProgramBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<ProgramList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findAdditionalProgramBilling.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing/additional_programs`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProgramListFromJSON(jsonValue));
    }

    /**
     * List all addition programs
     */
    async findAdditionalProgramBilling(requestParameters: FindAdditionalProgramBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<ProgramList> {
        const response = await this.findAdditionalProgramBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find program\'s billing details
     */
    async findOneBillingRaw(requestParameters: FindOneBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Find program\'s billing details
     */
    async findOneBilling(requestParameters: FindOneBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.findOneBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all billing plans
     */
    async findPlansBillingRaw(requestParameters: FindPlansBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingProductList>> {
        if (requestParameters.currency === null || requestParameters.currency === undefined) {
            throw new runtime.RequiredError('currency','Required parameter requestParameters.currency was null or undefined when calling findPlansBilling.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingProductListFromJSON(jsonValue));
    }

    /**
     * List all billing plans
     */
    async findPlansBilling(requestParameters: FindPlansBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingProductList> {
        const response = await this.findPlansBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all billing products
     */
    async findProductsBillingRaw(requestParameters: FindProductsBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingProductList>> {
        if (requestParameters.currency === null || requestParameters.currency === undefined) {
            throw new runtime.RequiredError('currency','Required parameter requestParameters.currency was null or undefined when calling findProductsBilling.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.currency !== undefined) {
            queryParameters['currency'] = requestParameters.currency;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/products`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingProductListFromJSON(jsonValue));
    }

    /**
     * List all billing products
     */
    async findProductsBilling(requestParameters: FindProductsBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingProductList> {
        const response = await this.findProductsBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove additional program from subscription
     */
    async removeAdditionalProgramBillingRaw(requestParameters: RemoveAdditionalProgramBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling removeAdditionalProgramBilling.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeAdditionalProgramBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing/additional_programs/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Remove additional program from subscription
     */
    async removeAdditionalProgramBilling(requestParameters: RemoveAdditionalProgramBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.removeAdditionalProgramBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove product from subscription
     */
    async removeProductBillingRaw(requestParameters: RemoveProductBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling removeProductBilling.');
        }

        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removeProductBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing/products/{id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Remove product from subscription
     */
    async removeProductBilling(requestParameters: RemoveProductBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.removeProductBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update billing details
     */
    async updateBillingRaw(requestParameters: UpdateBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BillingDetails>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateBilling.');
        }

        if (requestParameters.BillingDetails === null || requestParameters.BillingDetails === undefined) {
            throw new runtime.RequiredError('BillingDetails','Required parameter requestParameters.BillingDetails was null or undefined when calling updateBilling.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/billing`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BillingDetailsToJSON(requestParameters.BillingDetails),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BillingDetailsFromJSON(jsonValue));
    }

    /**
     * Update billing details
     */
    async updateBilling(requestParameters: UpdateBillingRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BillingDetails> {
        const response = await this.updateBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
